const ec2KeyPairs = `<?xml version="1.0" encoding="UTF-8"?>
<DescribeKeyPairsResponse xmlns="http://ec2.amazonaws.com/doc/2016-11-15/">
    <requestId>a1a872c1-a418-4156-8250-ee9e2f2a973f</requestId>
    <keySet>
        <item>
            <keyName>vishnub-ndas-dec19093033utc19-EDB-KEY</keyName>
            <keyPairId>key-0ec498011e1d3a283</keyPairId>
            <keyFingerprint>05:fc:2c:0c:ba:41:98:9b:b3:f8:0d:c2:8a:0b:1a:b5:65:01:0e:cd</keyFingerprint>
            <keyType>rsa</keyType>
            <createTime>2019-12-19T09:30:34.000Z</createTime>
            <tagSet/>
        </item>
    </keySet>
</DescribeKeyPairsResponse>
`

export default ec2KeyPairs;
